module.exports = __webpack_public_path__ + "static/media/laptop-min.4d723c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/laptop-min.png
// module id = 76
// module chunks = 0